var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.995 19.34h-2V18a1 1 0 0 1 2 0v1.34Z",
    fill: "#29C969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.316 10.49h12.622c.622 0 1.125.503 1.125 1.126v16.79c0 .623-.503 1.125-1.126 1.125H5.063a1.124 1.124 0 0 1-1.125-1.125V7.594c0-.623.503-1.125 1.126-1.125h8.936c.072 0 .141.028.194.077l4.123 3.945Zm2.68 7.51a3 3 0 1 0-6 0l.002 1.34a1 1 0 0 0-.998 1v4.56a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4.56a1 1 0 0 0-.997-1L20.995 18Z",
    fill: "#29C969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderLocked);
export default __webpack_public_path__ + "static/media/folder-locked.85fc40bd.svg";
export { ForwardRef as ReactComponent };